
// import React, { useEffect, useState } from "react";
// import { Upload, Button, message } from "antd";
// import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";

// const AudioUpload = ({ maxSizeMB = 5, onFileUpload, audioSrc = "" }) => {
//   const [fileList, setFileList] = useState([]);
//   const [audioPreview, setAudioPreview] = useState("");


//   useEffect(() => {
//     if (audioSrc) {
//       setAudioPreview(audioSrc);
//     }
//   }, [audioSrc]);

//   const handleChange = ({ file, fileList }) => {
//     if (file.status === "done") {
//       message.success(`${file.name} uploaded successfully!`);
//     } else if (file.status === "error") {
//       message.error(`${file.name} upload failed.`);
//     }

//     if (onFileUpload) {
//       onFileUpload(file.originFileObj || null);
//     }

//     if (file.originFileObj) {
//       setAudioPreview(URL.createObjectURL(file.originFileObj));
//     }

//     setFileList(fileList);
//   };


// const beforeUpload = (file) => {
//       const isValidType = file.type.startsWith("audio/");
  
//     if (!isValidType) {
//       message.error("Invalid file type! Only MP3 and AAC files are allowed.");
//       return false;
//     }
  
//     return true;
//   };
  
  

//   const handleRemove = () => {
//     setFileList([]);
//     setAudioPreview("");

//     if (onFileUpload) {
//       onFileUpload(null);
//     }
//   };

//   return (
//     <div style={{ textAlign: "center", padding: 20 }}>
//       <Upload
//         accept="audio/*"
//         fileList={fileList}
//         beforeUpload={beforeUpload}
//         onChange={handleChange}
//         onRemove={handleRemove}
//         maxCount={1}
//       >
//         <Button icon={<UploadOutlined />}>Upload MP3</Button>
//       </Upload>

//       {audioPreview && (
//         <div style={{ marginTop: 10 }}>
//           <audio controls>
//             <source src={audioPreview} type="audio/mp3" />
//             <source src={audioPreview} type="audio/aac" />
            
//             Your browser does not support the audio tag.
//           </audio>
//         </div>
//       )}

//       {fileList.length > 0 && (
//         <Button
//           type="danger"
//           icon={<DeleteOutlined />}
//           onClick={handleRemove}
//           style={{ marginTop: 10 }}
//         >
//           Remove MP3
//         </Button>
//       )}
//     </div>
//   );
// };

// export default AudioUpload;



import React, { useEffect, useState } from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { Spin } from "antd";


const AudioUpload = ({ maxSizeMB = 50, onFileUpload, onDurationExtracted, audioSrc = "", tip }) => {
  const [fileList, setFileList] = useState([]);
  const [audioPreview, setAudioPreview] = useState(audioSrc);
  const [autoPlay, setAutoPlay] = useState(false);
  const [userUploaded, setUserUploaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const {uploadLoading} = useSelector(prev => prev?.upload) 

  useEffect(() => {
    if (audioSrc) {
      setAudioPreview(audioSrc);
    }
  }, [audioSrc]);

  const beforeUpload = async (file) => {
    const isValidType = file.type.startsWith("audio/");
    setUserUploaded(true); 
  
    if (!isValidType) {
      message.error("Invalid file type! Only MP3 and AAC files are allowed.");
      return false;
    }

    const isUnderLimit = file.size / 1024 / 1024 < maxSizeMB;
    if (!isUnderLimit) {
      message.error(`File size must be less than ${maxSizeMB}MB.`);
      return false;
    }


    // Generate local preview before upload
    const audioURL = URL.createObjectURL(file);
    setAudioPreview(audioURL);
    setFileList([file]); // Store only the latest file

    // if (onFileUpload) {
    //   onFileUpload(file);
    // }
    setLoading(true);
  try {
    if (onFileUpload) {
      await onFileUpload(file); // wait for upload
    }
  } catch (err) {
    message.error("Upload failed.");
  } finally {
    setLoading(false);
  }


    const audio = new Audio(audioURL);
        audio.onloadedmetadata = () => {
        if (onDurationExtracted) {
            onDurationExtracted(audio.duration); // duration in seconds
        }
        };

    return false; // Prevent actual upload (since we're just previewing)
  };

  const handleRemove = () => {
    setFileList([]);
    setAudioPreview("");

    if (onFileUpload) {
      onFileUpload(null);
    }
  };

  return (
    <div style={{ textAlign: "center", padding: 20 }}>
      <Upload
        accept="audio/*"
        beforeUpload={beforeUpload}
        fileList={fileList.map((file) => ({ name: file.name, uid: file.uid }))}
        onRemove={handleRemove}
        maxCount={1}
        showUploadList={false} // Hide Ant Design's file list UI
      >
        <Button icon={<UploadOutlined />}>Upload Audio</Button>
      </Upload>
      {/* {uploadLoading ? "Loading... " : ""}
      {audioPreview && (
        <div style={{ marginTop: 10 }}>
          <audio key={audioPreview} controls autoPlay={autoPlay}>
            <source src={audioPreview} type="audio/mp3" />
            <source src={audioPreview} type="audio/aac" />
            Your browser does not support the audio tag.
          </audio>
        </div>
      )} */}
      <div>
            {loading ? (
        <Spin tip="Processing..." />
      ) : 
      (
        audioPreview && (
          <div style={{ marginTop: 10 }}>
            <audio key={audioPreview} controls autoPlay={autoPlay}>
              <source src={audioPreview} />
             
              Your browser does not support the audio tag.
            </audio>
          </div>
        )
      )}
      </div>


      {fileList.length > 0 || audioSrc && (
        <Button
          type="danger"
          icon={<DeleteOutlined />}
          onClick={handleRemove}
          style={{ marginTop: 10 }}
        >
          Remove Audio
        </Button>
      )}
    </div>
  );
};

export default AudioUpload;





